export default {"src":"/_next/static/media/message.9df77982.svg","height":36,"width":35,"blurWidth":0,"blurHeight":0};